module.exports = __webpack_public_path__ + "img/1026.23f1e68c.gif";